export const initialState = {
  plannedTrips: 0,
  problemCeils: 0,
  tripsCount: {
    planned: 0,
    actual: 0,
  },
  kilometrage: {
    planned: 0,
    actual: 0,
  },
  breaks: 0,
  deviations: 0,
}


export const set = (state, payload) => payload
